/**
 * Dave "registered a Best Deal" — "Done for you" line helpers
 *
 * Dave registers a deal on his own once it passes his profitability gate; the
 * backend writes one read-only card per child ASIN as soon as Amazon confirms
 * the upload, live until the deal starts. There is nothing to accept or
 * reject, so it only shows as a line in the "Done for you" section of
 * MultiDecisionAccordion, with the gate's explanation in a "Why?" tooltip.
 *
 * The card is US-only for now, so its prices are already USD.
 */

import { AGENT_INFO } from "../../constants";

const formatUsd = (value) =>
  value == null || Number.isNaN(Number(value))
    ? null
    : `$${Number(value).toFixed(2)}`;

const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

// "2026-11-08" → "Nov 8". Read from the string, not via new Date(): that
// parses it as UTC midnight and US time zones would show the day before.
const formatDealDate = (isoDate) => {
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(isoDate || "");
  if (!match) return null;
  return `${MONTHS[Number(match[2]) - 1]} ${Number(match[3])}`;
};

export const SELLER_CENTRAL_CANCEL_NOTE =
  "You can cancel it in Seller Central before it starts.";

export const isDaveRegistrationFailed = (daveData) =>
  daveData?.automated_execution_status === "all_attempts_failed";

export const buildDaveRegisteredDoneMessage = (daveData) => {
  const decision = daveData?.decision || {};
  const length = decision.deal_length_days
    ? `${decision.deal_length_days}-day `
    : "";
  const dealType = decision.deal_type || "Best Deal";
  const start = formatDealDate(decision.start_date);
  const starting = start ? ` starting ${start}` : "";
  const from = formatUsd(decision.previous_price ?? daveData?.selling_price);
  const to = formatUsd(decision.target_price);
  const priceChange = from && to ? `${from} → ${to}` : null;

  if (isDaveRegistrationFailed(daveData)) {
    const prices = priceChange ? ` (${priceChange})` : "";
    return `${AGENT_INFO.dave.name}'s ${length}${dealType}${starting}${prices} didn't go through on Amazon and won't run`;
  }
  const prices = priceChange ? ` — ${priceChange}` : "";
  return `${AGENT_INFO.dave.name} registered a ${length}${dealType}${starting}${prices}`;
};

// "Why?" tooltip: the gate's own sentence ("Needs +32% more sales to break
// even (threshold: +50%). Similar deals won 3 of 4 times.").
export const getDaveRegisteredDetailLines = (daveData) => {
  const reasoning = daveData?.decision?.reasoning;
  return reasoning ? [reasoning] : [];
};
